import { defineComponent as _defineComponent } from 'vue'
import DatasetTree from '@/components/dataset-tree/index.vue'
import IconLabel from '@/views/space-model/model-item/icon-label.vue'
import {
  datasetsToModelsComputed,
  datasetToModel,
  delModel,
  modelsToDatasets
} from '@/components/dataset-tree/constant'
import { showToolbox } from '@/store'
import { jobStatus, JOBEUM } from '@/store/setup'
import { Dialog } from '@kankan/components/src/expose-common'
import { DataSetRaw, main } from '@/store/dataset'
import {
  datasetSelect,
  list,
  ModelAtom,
  ModelRaw,
  ModelType
} from '@/store/model'
import Control from './control.vue'
import { useViewEdit } from '@/hook/useEdit'
import {
  useSDK,
  useDesave,
  genUseLoading,
  autoLeaveDisabled,
  customMouseMenuStack,
  customMouseMenuDisabledStack,
  mouseMenuDisabledStack,
  mouseConfigStack,
  useViewStack,
  laserModeStack
} from '@/hook'
import { AlignmentMode, DataSet, Mode } from '@/sdk'
import { reactive, Ref, ref, watch, watchEffect } from 'vue'
import { Loading, Message } from '@kankan/components/src/expose-common'
import { router, writeRouteName } from '@/router'
import { ui18n } from '@/lang'
import { genSingle } from '@/utils'
import { currentView, screenEnum } from '@/sdk/carry/fview/status'
import { showHotImage } from '@/store/setting'
import { closeCurrentHotImage } from '@/hook/useShadre'
import { customMap } from '../../hook/custom'
import { show } from '@/store/hot'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const store = reactive<{
  lightDatasets?: Ref<DataSetRaw>
  selectList?: Ref<ModelRaw<ModelType>>
  lightList?: Ref<ModelRaw<ModelType>>
  alignment?: Ref<AlignmentMode>
}>({})

// const lightDatasets = ref<DataSetRaw>([])
// const selectList = datasetsToModelsComputed(list, showList)
// const lightList = datasetsToModelsComputed(list, lightDatasets)
const sdk = useSDK()
const pushLight = (raw: ModelAtom) => {
  if (!delModel(store.lightList, raw)) {
    store.lightList = [raw]
  }

  // delModel(store.lightList, raw) || store.lightList.push(raw);
  store.lightList = [...store.lightList]
  isLocking(raw) && lockMsg()
}

const isLocking = (data: ModelAtom) => {
  const isLock = data.type === 'dataset' && data.origin.id === main.value.id
  return isLock
}

watch(
  () => [
    router.currentRoute.value?.params?.selectId || main.value?.id,
    store.alignment
  ],
  ([id, alignment]) => {
    if (alignment) {
      const datasets = modelsToDatasets(store.selectList)
      if (id) {
        const setDataset = datasets.find(atom => atom.id === id)
        setTimeout(() => {
          store.lightList = [datasetToModel(store.selectList, setDataset)]
        })
      }
    }
  },
  { flush: 'post' }
)

const lockMsg = () => Message.warning(ui18n.t('dataset.setting.lockTip'))

const sdkDatasets = sdk.scene.getDataSets()
watchEffect(() => {
  if (store.alignment) {
    store.lightList = store.lightList.filter(
      raw => store.selectList.includes(raw) && !isLocking(raw)
    )
    const datasets = sdkDatasets.filter(({ id }) =>
      store.lightDatasets.some(({ id: qid }) => id === qid)
    )
    store.alignment.selectDatasets(datasets)
  }
})

useViewEdit(() => {
  Loading.show()
  const lightDatasets = ref<DataSetRaw>([])
  store.lightDatasets = lightDatasets as any
  store.selectList = datasetSelect() as any
  store.lightList = datasetsToModelsComputed(list, lightDatasets) as any
  autoLeaveDisabled.push(ref(true))

  let needSave = true
  const changed = () => {
    if (needSave) {
      useDesave({
        save: genUseLoading(async () => {
          await new Promise<void>(resolve => {
            store.alignment.bus.on('saveSuccess', resolve)
            store.alignment.save()
          })
          jobStatus.value = JOBEUM.CALI
          needSave = true
        })
      })
      needSave = false
    }
  }

  // let stopWatch;
  const timeout = setTimeout(() => {
    store.alignment = sdk.enterAlignment()
    store.alignment.bus.on('moveInitialDataset', lockMsg)
    store.alignment.bus.on('changed', changed)
    // stopWatch = watchEffect(() => {
    //   if (store.lightList?.length) {
    //     store.alignment.focusDataset &&
    //       store.alignment.focusDataset((store.lightList[0] as any).origin.id);
    //   } else {
    //     store.alignment.focusDataset && store.alignment.focusDataset(null);
    //   }
    // });

    Loading.hide()
  }, 500)

  const popMode = laserModeStack.push(ref(Mode.cloud))

  const $direction = document.querySelector(
    '#scene-direction'
  ) as HTMLDivElement

  const stopWatch = watchEffect(onCleanup => {
    if (!$direction) return
    if (currentView.value !== screenEnum.Clound && currentView.value !== -1) {
      $direction.style.cssText = 'display: none !important;'
    } else {
      $direction.style.cssText = 'right: 10px;top:10px;'
    }
    onCleanup(() => ($direction.style.cssText = ''))
  })
  const oldShow = show.value
  show.value = false
  return () => {
    show.value = oldShow
    stopWatch()
    clearTimeout(timeout)
    autoLeaveDisabled.pop()
    popMode()
    if (store.alignment) {
      // stopWatch();
      store.alignment.bus.off('changed', changed)
      store.alignment.clear()
      store.alignment = null
    }
  }
})
const flyDataset = (dataset: ModelAtom) => {
  if (dataset.type === 'dataset') {
    store.alignment.focusOnDataset(dataset.origin.id)
  } else {
    useSDK().focusEntity(dataset.id)
  }
}

watch(
  () => [
    !!store.lightDatasets?.length &&
      router.currentRoute.value.name === writeRouteName.spaceDivision,
    currentView.value
  ],
  ([select, currentView], _, onCleanup) => {
    if (!select) return onCleanup(() => {})
    const w = sdk.scene.el.offsetWidth
    const h = sdk.scene.el.offsetHeight
    const bw = w / 2
    const bh = h / 2
    const solid = 2
    const bounds =
      currentView === screenEnum.Top
        ? [[0, 0, w, h]]
        : currentView === -1
        ? [[0, 0, bw - solid, bh - solid]]
        : []

    const menu = reactive({
      icon: 'move',
      label: ui18n.t('dataset.setting.moveCenter'),
      color: '#fff',
      click(pos, screen) {
        store.alignment.moveDataset(
          screen,
          store.lightDatasets.map(item => item.id)
        )
      }
    })
    const pop = genSingle(
      customMouseMenuStack.push(ref([menu])),
      customMouseMenuDisabledStack.push(ref(false)),
      mouseMenuDisabledStack.push(ref(false)),
      mouseConfigStack.push(ref({ current: true, bounds, canEmptyCol: true }))
    )
    onCleanup(() => {
      pop()
    })
  },
  { flush: 'sync' }
)

watch(
  () => mouseConfigStack.current.value?.value,
  data => {},
  { flush: 'sync' }
)

closeCurrentHotImage()

const __returned__ = { store, sdk, pushLight, isLocking, lockMsg, sdkDatasets, flyDataset, DatasetTree, IconLabel, get showToolbox() { return showToolbox }, get list() { return list }, Control }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})